import React from 'react';
import L from 'leaflet';
import { Marker, Pane } from 'react-leaflet';
import styled from '@emotion/styled';
import { useStoreState } from 'easy-peasy';

const LabelPane = styled(Pane)`
  .map-label {
    font-family: ${({ theme }) => theme.fonts.sans};
    pointer-events: none !important;
    text-transform: uppercase;
    letter-spacing: 1px;
    font-weight: 700;
    letter-spacing: 0.01em;
    user-select: none;
    line-height: 1.2;
    transition: color 250ms linear, text-shadow 250ms linear;
    font-size: 9px;
    text-align: center;
    height: 1px !important;
    width: 1px !important;
    margin: 0 !important;

    span {
      display: inline-block;
      transform: translateX(-50%) translateY(-50%);
    }

    ${({ theme }) => theme.breakpoints.sm.up} {
      font-size: 11px;
    }

    color: ${({ theme }) => theme.colors.black};
    text-shadow: 1px 0 1px rgba(255, 255, 255, 0.75),
      0 1px 1px rgba(255, 255, 255, 0.75), -1px 0 1px rgba(255, 255, 255, 0.75),
      0 -1px 1px rgba(255, 255, 255, 0.75);

    ${({ isDrawingEnabled }) =>
      isDrawingEnabled &&
      `
      color: white;
      text-shadow: 1px 0 0 rgba(0, 0, 0, 0.5), 0 1px 0 rgba(0, 0, 0, 0.5),
        -1px 0 0 rgba(0, 0, 0, 0.5), 0 -1px 0 rgba(0, 0, 0, 0.5);
    `}
  }
`;

const Labels = ({ data = [] }) => {
  const isDrawingEnabled = useStoreState((state) => state.app.isDrawingEnabled);
  return (
    <LabelPane isDrawingEnabled={isDrawingEnabled}>
      {data.map((d) => {
        const icon = L.divIcon({
          className: 'map-label',
          html: `<span>${d[0]}</span>`,
        });

        return (
          <Marker
            key={`MapLabel__${d[0]}`}
            position={[d[1], d[2]]}
            icon={icon}
          />
        );
      })}
    </LabelPane>
  );
};

export default Labels;
